/*
  $50 tester credit (UNLOCK50)
  Unlock Collection buyers have already tried every scent, so when the credit applies to the cart:
  - no free tester mini is auto-added, and any existing one is removed
  - the timeline shows "$50 credit" in the tester's place (snippets/cart-timeline.liquid)
  If the credit comes off, the testers it replaced are added back.

  Loaded from snippets/cart-drawer.liquid. Patches belnu-main.js on DOMContentLoaded — this
  listener is registered before belnu-main.js's, so the patches land before its classes start.
*/
(function () {
  var CODE = 'UNLOCK50';
  var STORE = 'belnuCreditMinis';

  function hasCredit(cart) {
    var codes = (cart.discount_codes || []).some(function (c) {
      return c.applicable && String(c.code).toUpperCase() === CODE;
    });
    var apps = (cart.cart_level_discount_applications || []).some(function (a) {
      return String(a.title || '').toUpperCase() === CODE;
    });
    return codes || apps;
  }
  function readOwed() {
    try { return JSON.parse(sessionStorage.getItem(STORE) || '[]'); } catch (e) { return []; }
  }
  function writeOwed(list) {
    try {
      if (list.length) sessionStorage.setItem(STORE, JSON.stringify(list));
      else sessionStorage.removeItem(STORE);
    } catch (e) {}
  }
  function isMini(item) {
    return item.properties && item.properties._auto_mini === 'true';
  }
  function dispatch(data, silent) {
    window.dispatchEvent(new CustomEvent('belnuQuickAdd', { detail: { response: data, silent: !!silent } }));
  }

  var miniAdder = null;

  // Replaces autoRemoveMiniProducts() from belnu-main.js (its belnuCartUpdated listener calls it by name)
  async function autoRemoveMiniProducts(silent) {
    try {
      var cart = await fetch('/cart.js').then(function (r) { return r.json(); });
      var credit = hasCredit(cart);
      var parents = cart.items.filter(function (i) { return !isMini(i); }).map(function (i) { return i.product_title; });

      // Credit came off: give back the testers it replaced
      if (!credit) {
        var owed = readOwed();
        if (owed.length && miniAdder) {
          writeOwed([]);
          for (var k = 0; k < owed.length; k++) {
            var parent = owed[k].parent;
            if (parents.indexOf(parent) === -1) continue;
            var handle = await miniAdder.findMiniProduct(parent);
            if (handle) await miniAdder.addMiniToCart(handle, parent, silent);
          }
          return;
        }
      }

      var minis = cart.items.filter(isMini);
      for (var j = 0; j < minis.length; j++) {
        var mini = minis[j];
        var parentTitle = mini.properties._parent_product;
        var orphaned = parents.indexOf(parentTitle) === -1;
        if (!credit && !orphaned) continue;

        if (credit && !orphaned) {
          var list = readOwed();
          if (!list.some(function (o) { return o.parent === parentTitle; })) list.push({ parent: parentTitle });
          writeOwed(list);
        }

        var fresh = await fetch('/cart.js').then(function (r) { return r.json(); });
        var line = fresh.items.findIndex(function (i) { return i.key === mini.key; });
        if (line !== -1) {
          var res = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              line: line + 1,
              quantity: 0,
              sections: ['cart-drawer', 'main-cart'],
              sections_url: window.location.pathname
            })
          });
          if (res.ok) dispatch(await res.json(), silent);
        }
        await new Promise(function (r) { setTimeout(r, 25); });
      }
    } catch (e) {
      console.error('Error during auto-removal of mini products:', e);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    window.autoRemoveMiniProducts = autoRemoveMiniProducts;

    if (typeof BelnuMiniAutoAdd !== 'undefined') {
      var proto = BelnuMiniAutoAdd.prototype;

      // No tester while the credit applies
      var origCheck = proto.checkAndAddMini;
      proto.checkAndAddMini = function (addedItem, currentCart) {
        if (currentCart && hasCredit(currentCart)) return Promise.resolve();
        return origCheck.call(this, addedItem, currentCart);
      };

      // Quiet adds (page-load restore) re-render the drawer without opening it
      proto.addMiniToCart = async function (miniHandle, parentProductTitle, silent) {
        try {
          var product = await fetch('/products/' + miniHandle + '.js').then(function (r) { return r.json(); });
          if (!product.available) return;
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: product.variants[0].id,
                quantity: 1,
                properties: {
                  _auto_mini: 'true',
                  _parent_product: parentProductTitle,
                  _note: 'Complimentary mini included with ' + parentProductTitle
                }
              }],
              sections: ['cart-drawer', 'main-cart'],
              sections_url: window.location.pathname
            })
          });
          if (res.ok) dispatch(await res.json(), silent);
        } catch (e) {
          console.error('Error adding mini to cart:', e);
        }
      };

      var origInit = proto.init;
      proto.init = function () {
        miniAdder = this;
        return origInit.apply(this, arguments);
      };
    }

    if (typeof BelnuCartDrawer !== 'undefined') {
      var origOpen = BelnuCartDrawer.prototype.open;
      BelnuCartDrawer.prototype.open = function (e) {
        if (e && e.detail && e.detail.silent) return;
        return origOpen.apply(this, arguments);
      };
    }

    // Catch a credit applied via a /discount link (or removed at checkout) without popping the drawer open.
    // Runs after belnu-main.js's own DOMContentLoaded setup.
    setTimeout(function () { autoRemoveMiniProducts(true); }, 0);
  });
})();
